import { useHistory } from "react-router-dom";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MenuItems
Description : Componente que contiene la información de los botones de la barra de navegación de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen los botones de la barra de navegación.
================================================================================ */
export default function MenuItems8() {
    let history = useHistory();
    const items = [
        {
            label: 'Empleados',
            path: "/Employes",
            index: 0,
        },
        {
            label: 'Cambio de salarios',
            path: "/SalaryChange",
            index: 1,
        },
        {
            label: 'Saldos iniciales',
            path: "/InitialBalance",
            index: 2,
        },
        {
            label: 'Documentos',
            path: "/Documents",
            index: 3,
        }
    ]
    return items
}
